import { activateEscapeKeyListener, deactivateEscapeKeyListener } from './utils'

/**
 * Builds the modal instance.
 * @param {jQuery} idOrInstance
 * @return {Modal}
 */
export default class Modal {
  constructor (instance) {
    this.$instance = instance
    this.$content = this.$instance.find('.modal-content-inner')
    this.onShow = Function
    this.onHide = Function

    // Handle closing modal by button
    this.$instance.on('click', '.modal-close', (e) => {
      e.preventDefault()
      this.hide()
    })

    // Handle closing modal by clicking on overlay
    this.$instance.on('click', (e) => {
      if (e.target && e.target.className === 'modal show') {
        this.hide()
      }
    })

    activateEscapeKeyListener(() => { this.hide() })
  }

  isVisible () {
    this.$instance.hasClass('show')
  }

  /**
     * Show the modal
     *
     * @return {Modal}
     */
  show () {
    if (this.isVisible()) {
      return this
    }

    $('body')
      .addClass('modal-open')
      .append('<div class="modal-backdrop show"></div>')

    this.$instance
      .addClass('show')
      .show()

    this.onShow()

    return this
  }

  /**
     * Hide the modal
     *
     * @return {Modal}
     */
  hide () {
    deactivateEscapeKeyListener()

    if (this.isVisible() === false) {
      return this
    }

    $('body').removeClass('modal-open')
    $('.modal-backdrop').remove()
    this.$instance.remove()

    this.onHide()

    return this
  }
}
